<template>
    <button
        class="tiptap-btn"
        type="button"
        :title="$t('Clear formatting')"
        :disabled="disabled"
        @click="editor.chain().focus().clearNodes().unsetAllMarks().run()">
        <FormatClearIcon size="16"/>
    </button>
</template>

<script>
import FormatClearIcon from '@/common/components/svg-icons/FormatClearIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarClearButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FormatClearIcon
    }
};
</script>
